/* eslint-disable no-console */
import { Grid } from "@mui/material";
import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import InputGroup from "../../../components/FormComponent/InputGroup";
import styles from "../report.module.css";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import CustonTemplate from "../Template/CustomTemplate";
import Button from "../../../components/Button";
import NotFounditem from "../../error/NotFound";
import nosearch from "../../../assets/images/no-search.svg";
import Select from "react-select";
import useValidator from "../../../hooks/useValidator";
import { useUserState } from "../../../context/UserContext";

const CLASSES_ENDPOINT = "/api/v1/class";
const GET_SESSIONS = "/api/v1/school-plan/session";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GELL_ALL_SUBJECT_ENDPOINT = "/api/v1/subjects";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const STUDENTS_ENDPOINT = "/api/v1/students";
const CUSTOM_REPORT_ENDPOINT = "/api/v1/custom-reports";

const CreateCustomReport = () => {
  const { appLogo } = useUserState();
  const [classesData, setClassData] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [selectedSession, setSelectedSession] = useState("");
  const [subjectsData, setSubjectsData] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [extraColumns, setExtraColumns] = useState({
    exam: false,
    grade: false
  });
  const [reportConfig, setReportConfig] = useState(null);
  const [allStudents, setAllStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [reportTarget, setReportTarget] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [reportValidator, showCreateValidationMessage] = useValidator();

  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        const filteredTerms = res?.data?.data?.filter(
          (term) => term?.session_id === Session_ID
        );

        setSelectedSessionTerms(filteredTerms || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data || "Failed to fetch terms");
      });
  };

  const getAllSubjects = () => {
    httprequest.get(GELL_ALL_SUBJECT_ENDPOINT).then((res) => {
      setSubjectsData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const getAllStudents = () => {
    httprequest.get(STUDENTS_ENDPOINT).then((res) => {
      setAllStudents(res?.data?.data?.map((student) => {
        return {
          label: `${student?.student?.first_name} ${student?.student?.last_name}`,
          value: student?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const getAllObtainableScores = () => {
    // setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === selectedSession));
      })
      .catch((err) => {
        // setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    setSelectedSession(Session_ID);
    getAllTerms(Session_ID);
  };

  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
  };

  const handleStudentChange = (selectedOption) => {
    setSelectedStudent(selectedOption?.value || "");
  };

  const proceedToApply = () => {
    setIsLoading(true);
    const selectedSubjectIds = subjectsData
      .filter((s) => s.selected)
      .map((s) => s.id);

    const selectedColumns = obtainablescore?.[0]?.ca
      ?.filter((ca) => ca.selected)
      ?.map((ca) => ca.ca_type) || [];

    const reportData = {
      title,
      term_id: aselectedTerm,
      subjects: selectedSubjectIds,
      columns: selectedColumns,
      type: reportTarget
    };
    if (reportTarget === "class") {
      reportData.class_id = selectedClass;
    }

    if (reportTarget === "student") {
      reportData.student_id = selectedStudent;
    }

    setReportConfig({
      ...reportData,
      caColumns: selectedColumns,
      exam: extraColumns.exam,
      grade: extraColumns.grade
    });

    httprequest.post(CUSTOM_REPORT_ENDPOINT, reportData)
      .then((res) => {
        toast.success(res.data?.message || "Report configuration saved successfully");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to save configuration");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleApply = () => {
    reportValidator.allValid()
      ? proceedToApply()
      : showCreateValidationMessage(true);
  };

  const handleClear = () => {
    setTitle("");
    setSelectedClass("");
    setSelectedSession("");
    setASelectedTerm("");
    setReportTarget("");
    setSelectedStudent(null);
    setReportConfig(null);

    setSubjectsData(prev => prev.map(s => ({ ...s, selected: false })));
    setObtainableScore(prev => [
      {
        ...prev[0],
        ca: prev[0]?.ca?.map(ca => ({ ...ca, selected: false })) || []
      }
    ]);

    setExtraColumns({
      exam: false,
      grade: false
    });
  };

  useEffect(() => {
    if (selectedSession) {
      getAllTerms(selectedSession);
      getAllObtainableScores();
    }
  }, [selectedSession]);

  useEffect(() => {
    getAllSessions();
    getAllClasses();
    getAllStudents();
    getAllSubjects();
  }, []);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/report/custom"
                link_one_name="Custom Report"
                active="Create Custom Report"
                description="Create your custom report here"
              />
            </div>
          </div>

          <div className={styles.custom_grid}>
            <div className={styles.custom_left}>
              {reportConfig ? (
                <CustonTemplate reportConfig={reportConfig} appLogo={appLogo} />) : (
                <div className={`${styles.notfound}`}>
                  <NotFounditem
                    img={nosearch}
                    title="No Report Available"
                    subtitle="Fill the form to Customize your report"
                  />
                </div>
              )}
            </div>
            <div
              className={
                reportConfig ? styles.customActive : styles.custom
              }
            >
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  required
                  margin="normal"
                  inputType="text"
                  inputName="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {reportValidator.message("title", title, "required")}
              </Grid>
              <div className={styles.radio_group}>
                <label>
                  <input type="radio" name="target" value="student" checked={reportTarget === "student"}
                    onChange={() => setReportTarget("student")}
                  />
                  <span>For Student</span>
                </label>

                <label>
                  <input type="radio" name="target" value="class" checked={reportTarget === "class"}
                    onChange={() => setReportTarget("class")}
                  />
                  <span>For Class</span>
                </label>
              </div>
              {reportTarget === "student" &&
              <Grid item lg={12} md={12} sm={6} xs={12}>
                <div className="multiple-select">
                  <Select onChange={handleStudentChange} name="wards"
                    closeMenuOnSelect={true} options={allStudents}
                  />
                </div>
                {reportValidator.message("selectedStudent", selectedStudent, reportTarget === "student" ? "required" : "")}
              </Grid>
              }
              {reportTarget === "class" &&
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <SelectGroup
            children={
              <select name="class" value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                <option value="">--All Class--</option>
                {classesData?.map((data) => {
                  return (
                    <option key={data?.id} value={data?.id}>
                      {data?.class_name}
                    </option>
                  );
                })}
              </select>
            }
          />
          {reportValidator.message("class_id", selectedClass, "required")}
        </Grid>
              }
              {(reportTarget === "student" || reportTarget === "class") &&
      <>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <SelectGroup
            children={
              <select
                onChange={handleSessionChange}
                value={selectedSession}
                name="session"
              >
                <option value="">---Select Session---</option>
                {allSessions?.map((sesh) => {
                  return (
                    <option key={sesh?.id} value={sesh?.id}>
                      {sesh?.session}
                    </option>
                  );
                })}
              </select>
            }
          />
          {reportValidator.message("session_id", selectedSession, "required")}
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <SelectGroup
            children={
              <select name="term" value={aselectedTerm} onChange={handleTermChange}>
                <option value="">---Select Term---</option>
                {selectedSessionTerms?.map((data) => {
                  return (
                    <option key={data?.id} value={data?.id}>
                      {data?.term}
                    </option>
                  );
                })}
              </select>
            }
          />
          {reportValidator.message("term_id", aselectedTerm, "required")}
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className={styles.subjects_container}>
            <label className={styles.subjects_header}>
              <input
                type="checkbox"
                onChange={(e) => {
                  const checked = e.target.checked;
                  if (checked) {
                    // select all subject ids
                    setSubjectsData((prev) => prev.map((s) => ({ ...s, selected: true }))
                    );
                  } else {
                    // unselect all
                    setSubjectsData((prev) => prev.map((s) => ({ ...s, selected: false }))
                    );
                  }
                }}
                checked={subjectsData.length > 0 && subjectsData.every((s) => s.selected)}
              />
              <span>All Subjects</span>
            </label>

            <div className={styles.subjects_list}>
              {subjectsData?.map((subj) => (
                <label key={subj?.id} className={styles.subject_item}>
                  <input
                    type="checkbox"
                    checked={!!subj?.selected}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setSubjectsData((prev) => prev.map((s) => s.id === subj.id ? { ...s, selected: checked } : s
                      )
                      );
                    }}
                  />
                  <span>{subj?.subject_name || subj?.name}</span>
                </label>
              ))}
            </div>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className={styles.subjects_container}>
            {/* Header */}
            <label className={styles.subjects_header}>
              <input
                type="checkbox"
                onChange={(e) => {
                  const checked = e.target.checked;
                  if (checked) {
                    // select all columns
                    setObtainableScore((prev) => [
                      {
                        ...prev[0],
                        ca: prev[0]?.ca?.map((ca) => ({ ...ca, selected: true }))
                      }
                    ]);
                    setExtraColumns({ exam: true, grade: true });
                  } else {
                    // unselect all columns
                    setObtainableScore((prev) => [
                      {
                        ...prev[0],
                        ca: prev[0]?.ca?.map((ca) => ({ ...ca, selected: false }))
                      }
                    ]);
                    setExtraColumns({ exam: false, grade: false });
                  }
                }}
                checked={
                  (obtainablescore?.[0]?.ca?.length > 0 &&
            obtainablescore[0].ca.every((ca) => ca.selected)) &&
          extraColumns.exam &&
          extraColumns.grade
                }
              />
              <span>Select Columns</span>
            </label>

            {/* List of columns */}
            <div className={styles.subjects_list}>
              {/* Obtainable scores */}
              {obtainablescore?.[0]?.ca?.map((ca) => (
                <label key={ca?.ca_type} className={styles.subject_item}>
                  <input
                    type="checkbox"
                    checked={!!ca?.selected}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setObtainableScore((prev) => [
                        {
                          ...prev[0],
                          ca: prev[0]?.ca?.map((c) => c.ca_type === ca.ca_type ? { ...c, selected: checked } : c
                          )
                        }
                      ]);
                    }}
                  />
                  <span>{ca.ca_type}</span>
                </label>
              ))}

              {/* Exam */}
              <label className={styles.subject_item}>
                <input
                  type="checkbox"
                  checked={extraColumns.exam}
                  onChange={(e) => setExtraColumns((prev) => ({
                    ...prev,
                    exam: e.target.checked
                  }))
                  }
                />
                <span>Exam</span>
              </label>

              {/* Grade */}
              <label className={styles.subject_item}>
                <input
                  type="checkbox"
                  checked={extraColumns.grade}
                  onChange={(e) => setExtraColumns((prev) => ({
                    ...prev,
                    grade: e.target.checked
                  }))
                  }
                />
                <span>Grade</span>
              </label>
            </div>
          </div>
        </Grid>
      </>}
              <div className="flex gap-10 margin-top-16">
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  buttonName="Apply"
                  onClick={handleApply}
                  isLoading={isLoading}
                />
                <Button
                  variant="primaryoutline"
                  buttonSize="fluid"
                  color="btnfontprimary"
                  buttonName="Clear"
                  onClick={handleClear}
                />
              </div>
            </div>
          </div>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default CreateCustomReport;
